<template>
  <div class="html-editor mt-2">
    <div
      class="d-flex flex-row justify-content-between align-items-center flex-nowrap"
    >
      <span :class="titleClass">{{ this.title }}</span>
      <HMButton color="brand" @click="edit" v-if="showContent">
        {{ $t('GENERAL.BUTTON.EDIT') }}
      </HMButton>
    </div>
    <div class="notification mt-4" v-if="showConversionNotification">
      {{ $t('GENERAL.TEXT.HTML_CONVERSION_WARNING', { applicationName }) }}
    </div>
    <div
      v-if="showContent"
      class="inner-editor-container mt-2 pointer"
      @click="edit"
    >
      <HMCustomContent :html="htmlValue" :json="value" />
    </div>
    <div v-else class="add-content mt-1" @click="edit">
      <h5 class="m-0">+ {{ addContentText }}</h5>
    </div>
    <div v-if="showContent && faded" class="faded"></div>
  </div>
</template>

<script>
import HMHTMLEditorModal from './HMHTMLEditorModal';
import { getConfig } from '@/web/utils/configuration';

export default {
  name: 'HMHTMLEditor',
  props: {
    value: {
      type: String,
    },
    htmlValue: {
      type: String,
    },
    title: {
      type: String,
      default: '',
    },
    addContentText: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    faded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showConversionNotification() {
      return this.htmlValue && !this.value;
    },
    applicationName() {
      return getConfig().applicationName;
    },
    showContent() {
      return !this.addContentText || this.htmlValue || this.value;
    },
  },
  methods: {
    edit() {
      this.$modal.show(
        HMHTMLEditorModal,
        {
          value: this.value || null, // prevent undefined
          htmlValue: this.htmlValue || null,
          title: this.title,
          onUpdate: jsonData => {
            const strJSON = JSON.stringify(jsonData);
            this.$emit('input', strJSON);
            this.$emit('onUpdate', strJSON);
          },
        },
        {
          clickToClose: false,
          classes: ['vm--inline-modal'],
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.notification {
  padding: 0.5rem 1rem;
  border-radius: $border-radius;
  background-color: rgba($dark-red, 0.2);
  color: $dark-red;
}

.add-content {
  display: flex;
  align-items: center;
  padding: 1rem;
  min-height: 64px;
  background: $lightest-gray;
  border: 1px solid $light-gray;
  border-radius: $border-radius;
  cursor: pointer;
}

.inner-editor-container {
  max-width: 75%;
}

.faded {
  bottom: 30%;
  right: 0;
  left: 0;
  width: 100%;
  height: 25%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, white 98%);
  position: absolute;
  opacity: 1;
  z-index: 5;
}
</style>
